import { axios } from '@/axios.config';
import { mockAdapter } from '@/mocks/axiosMockAdapter.config';

export const state = {
  flags: {
    data: [],
    loading: false,
    error: null,
  },
};

export const actions = {
  /**
   * Fetch Global flag
   * @returns {Promise}
   */
  fetchGlobalFlag({ commit }) {
    const url = `/feature`;

    mockAdapter(axios, 'get', url, 'getGlobalFlags', 200);
    commit('requestStart', { key: 'flags' });

    return axios
      .get(url)
      .then(res => {
        commit('updateFlags', res.data);
        // Dev Tools
        commit('devTools/setFlags', res.data, { root: true });

        commit('requestSucceed', { key: 'flags' });
      })
      .catch(() => {
        commit('requestFailed', { key: 'flags' });
      });
  },
};

export const mutations = {
  updateFlags(state, data) {
    state.flags.data = data;
  },

  requestStart(state, { key }) {
    state[key]['loading'] = true;
    state[key]['error'] = null;
  },

  requestSucceed(state, { key }) {
    state[key]['loading'] = false;
  },

  requestFailed(state, { key }) {
    state[key]['loading'] = false;
    state[key]['error'] = true;
  },
};

export const getters = {
  getFlags(state) {
    return state.flags.data ? state.flags.data : [];
  },
};
